import { motion } from "framer-motion";
import React, { useMemo, useState } from "react";
import { Collapse, Container } from "react-bootstrap";
import { IsBeta } from "../utils/Network";
import { isMobile } from "react-device-detect";
import { GameAnnouncements } from "../types/global";
import { useSelector } from "react-redux";

type Props = {};

const StickyHeader = (props: Props) => {
  const { stickyHeaders }: GameAnnouncements = useSelector(
    (state: any) => state.announcements
  );
  const [isHide, setIsHide] = useState(false);
  const stickyHeader = useMemo(() => {
    return stickyHeaders.filter((header) => header.isActive)?.[0];
  }, [stickyHeaders]);

  return (
    <div>
      {stickyHeader && (
        <>
          <Collapse appear={!isMobile} in={!isHide}>
            <motion.div
              exit={{ opacity: 0, y: -300 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.5 }}
              style={{
                backgroundColor: stickyHeader.backgroundColor,
                color: stickyHeader.textColor,
              }}
              className="pt-2 pb-2 text-center pointer "
            >
              <Container className="d-flex text-shadow flex-wrap fs-sm-small">
                <div style={{ textAlign: "justify" }}>
                  {stickyHeader.description}
                </div>
                <div style={{ flexGrow: 1 }} />
                <a target="_blank" href={stickyHeader.link}>
                  <div style={{ color: stickyHeader.textColor}} className="me-2 bold">
                    {stickyHeader.text}
                  </div>
                </a>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsHide(true);
                  }}
                  className="button ms-auto text-white btn-close bg-white"
                ></button>
              </Container>
            </motion.div>
          </Collapse>
          <Collapse in={isHide}>
            <motion.div
              exit={{ opacity: 0, y: -300 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.5 }}
            >
              <Container
                style={{
                  textAlign: "end",
                  position: "absolute",
                  top: 0,
                  right: 0,
                }}
                className=" w-100"
              >
                <img
                  width={40}
                  height={40}
                  className="button"
                  onClick={() => {
                    setIsHide(false);
                  }}
                  src={"/assets/images/icons/warning.png"}
                />
              </Container>
            </motion.div>
          </Collapse>
        </>
      )}
    </div>
  );
};

export default StickyHeader;
